import React from 'react'
import { Text, ScrollView, TouchableOpacity, View, useWindowDimensions } from 'react-native'
import { ACSharedStyles } from '../../admin-config-common'
import { SectionCol, SectionContent, SectionRow } from '@pulseops/submission/common'
import {
  AppContext,
  assets,
  DatePicker,
  ErrorHandling,
  HightLightTable,
  HightLightTableColum,
  Input,
  Permission,
  PulseOpsFormat,
  SelectSearch,
  sharedStyle
} from '@pulseops/common'
import { useTranslation } from 'react-i18next'
import { OPLSharedStyles } from '@pulseops/submission'
import { makeStyles } from '@material-ui/core'
import { useIsFocused, useNavigation } from '@react-navigation/native'
import { pipe } from 'fp-ts/lib/function'
import { ACMetricHistoryDetailService, ACViewMetricListService } from '../../admin-config-service'
import { ACMetricHistoryDetailForm } from './ACMetricHistoryDetailForm'
import { ZIO } from '@mxt/zio'
import { useLoading } from '@mxt/zio-react'
import { Controller, useForm } from 'react-hook-form'
import { ACMetricHistoryDetailConst } from './ACMetricHistoryDetailConst'
import { AdministrationConfigContext } from '../../AdministrationConfigContext'

export const ACMetricHistoryDetail = () => {
  const { t } = useTranslation()
  // const classes = makeACStyles()
  const { height, width } = useWindowDimensions()
  const [isLoading, bindLoader] = useLoading(false)
  const rootNavigation = useNavigation()
  const isFocused = useIsFocused()
  const { changeBreadcrumb, showGlobalLoading } = React.useContext(AppContext.AppContextInstance)
  const { userPermissions } = React.useContext(AdministrationConfigContext)
  const [searchedMetricDetailList, setSearchedMetricDetailList] = React.useState<
    ACMetricHistoryDetailService.MetricHistoryDetailInfo[]
  >([])
  const [metricGroups, setMetricGroups] = React.useState<ACViewMetricListService.ACMetricGroupInfo[]>([])
  const [pageNum, setPageNum] = React.useState<number>(0)
  const [pageSize, setPageSize] = React.useState<number>(10)
  const [total, setTotal] = React.useState<number>(0)
  const { control, getValues } = useForm<ACMetricHistoryDetailForm.ACSearchedMetricHistoryDetail>({
    defaultValues: {
      from: null,
      to: null,
      groupMetric: undefined,
      creator: '',
      status: undefined
    }
  })

  const useStyles = makeStyles({
    container: {
      border: `1px solid #D3DCE6`,
      borderWidth: 1,
      borderRadius: 8,
      maxHeight: height - 400,
      maxWidth: width - 40
    }
  })

  const displayedColumns: HightLightTableColum[] = [
    {
      title: t('AdministratorConfig:RequestID'),
      fieldName: 'requestID'
    },
    {
      title: t('AdministratorConfig:Status'),
      fieldName: 'status'
    },
    {
      title: t('AdministratorConfig:Type'),
      fieldName: 'type'
    },
    {
      title: t('AdministratorConfig:Creator'),
      fieldName: 'creator'
    },
    {
      title: t('AdministratorConfig:RequestedDate'),
      fieldName: 'requestedDate'
    },
    {
      title: t('AdministratorConfig:Approver'),
      fieldName: 'approver'
    },
    {
      title: t('AdministratorConfig:ApprovedDate'),
      fieldName: 'approvedDate'
    },
    {
      title: t('AdministratorConfig:GroupMetrics'),
      fieldName: 'groupMetrics'
    },
    {
      title: t('AdministratorConfig:MetricName'),
      fieldName: 'metricName'
    },
    {
      title: t('AdministratorConfig:Value'),
      fieldName: 'value'
    },
    {
      title: t('AdministratorConfig:Description'),
      fieldName: 'description'
    },
    {
      title: t('AdministratorConfig:OldOperator'),
      fieldName: 'oldOperator',
      disabled: true,
      isHightLightCol: (selectedRow) => {
        const dataItem = selectedRow.selectItem
        const oldOperator = dataItem['oldOperator'].toString()
        const newOperator = dataItem['newOperator'].toString()
        return oldOperator !== newOperator
      }
    },
    {
      title: t('AdministratorConfig:NewOperator'),
      fieldName: 'newOperator',
      disabled: true,
      isHightLightCol: (selectedRow) => {
        const dataItem = selectedRow.selectItem
        const oldOperator = dataItem['oldOperator'].toString()
        const newOperator = dataItem['newOperator'].toString()
        return oldOperator !== newOperator
      }
    },
    {
      title: t('AdministratorConfig:OldOperatorValue'),
      fieldName: 'oldOperatorValue',
      disabled: true,
      isHightLightCol: (selectedRow) => {
        const dataItem = selectedRow.selectItem
        const oldOperatorValue = dataItem['oldOperatorValue'].toString()
        const newOperatorValue = dataItem['newOperatorValue'].toString()
        return oldOperatorValue !== newOperatorValue
      }
    },
    {
      title: t('AdministratorConfig:NewOperatorValue'),
      fieldName: 'newOperatorValue',
      disabled: true,
      isHightLightCol: (selectedRow) => {
        const dataItem = selectedRow.selectItem
        const oldOperatorValue = dataItem['oldOperatorValue'].toString()
        const newOperatorValue = dataItem['newOperatorValue'].toString()
        return oldOperatorValue !== newOperatorValue
      }
    },
    {
      title: t('AdministratorConfig:OldRAGScore'),
      fieldName: 'oldRAGScore',
      disabled: true,
      isHightLightCol: (selectedRow) => {
        const dataItem = selectedRow.selectItem
        const oldRAGScore = dataItem['oldRAGScore'].toString()
        const newRAGScore = dataItem['newRAGScore'].toString()
        return oldRAGScore !== newRAGScore
      }
    },
    {
      title: t('AdministratorConfig:NewRAGScore'),
      fieldName: 'newRAGScore',
      disabled: true,
      isHightLightCol: (selectedRow) => {
        const dataItem = selectedRow.selectItem
        const oldRAGScore = dataItem['oldRAGScore'].toString()
        const newRAGScore = dataItem['newRAGScore'].toString()
        return oldRAGScore !== newRAGScore
      }
    },
    {
      title: t('AdministratorConfig:OldMultiplier'),
      fieldName: 'oldMultiplier',
      disabled: true,
      isHightLightCol: (selectedRow) => {
        const dataItem = selectedRow.selectItem
        const oldMultiplier = dataItem['oldMultiplier'].toString()
        const newMultiplier = dataItem['newMultiplier'].toString()
        return oldMultiplier !== newMultiplier
      }
    },
    {
      title: t('AdministratorConfig:NewMultiplier'),
      fieldName: 'newMultiplier',
      disabled: true,
      isHightLightCol: (selectedRow) => {
        const dataItem = selectedRow.selectItem
        const oldMultiplier = dataItem['oldMultiplier'].toString()
        const newMultiplier = dataItem['newMultiplier'].toString()
        return oldMultiplier !== newMultiplier
      }
    }
  ]

  React.useEffect(() => {
    if (isFocused) {
      changeBreadcrumb([
        {
          title: '',
          navigate: () => {
            rootNavigation.navigate('HomeScreen')
          }
        },
        {
          title: t('AdministratorConfig:HistoryDetail'),
          navigate: null
        }
      ])
      if (userPermissions && userPermissions.length > 0) {
        if (!userPermissions.includes(Permission.LinkHistoryDetailBSCAdminConfig)) {
          rootNavigation.navigate('HomeScreen')
        } else {
          setPageNum(0)
          setPageSize(10)
          getMetricGroups()
          getSearchedList(0, 10)
        }
      }
    }
  }, [isFocused, userPermissions])

  React.useEffect(() => {
    showGlobalLoading(isLoading)
  }, [isLoading])

  const getMetricGroups = () => {
    pipe(
      ACViewMetricListService.getACMetricGroupList,
      ZIO.map((response) => {
        if (response && response.length > 0) {
          setMetricGroups(response)
        } else {
          setMetricGroups([])
        }
        return response
      }),
      ZIO.unsafeRun({})
    )
  }

  const getSearchedList = (pageNo: number, pageSi: number) => {
    const formData = getValues()
    const fromDate = formData.from ? PulseOpsFormat.serviceInquiry_StartOfDate(formData.from, true).toISOString() : ''
    const toDate = formData.to ? PulseOpsFormat.serviceInquiry_endOfDate(formData.to, true).toISOString() : ''
    const bodyData: ACMetricHistoryDetailService.ACMetricHistoryDetailRequest = {
      start: pageNo,
      size: pageSi,
      orders: [],
      sort: null,
      status: formData.status?.value || '',
      createdBy: formData.creator || '',
      groupId: formData.groupMetric?.value || '',
      fromDate: fromDate,
      toDate: toDate,
      isPaginate: true
    }
    pipe(
      ACMetricHistoryDetailService.getACMetricHistoryDetailList(bodyData),
      ZIO.map((metricResponse) => {
        if (metricResponse.data && metricResponse.data.length > 0) {
          const searchedArr: ACMetricHistoryDetailService.MetricHistoryDetailInfo[] = metricResponse.data.map(
            (historyItem) => {
              const requestedDate = historyItem.createdAt
                ? PulseOpsFormat.dateStringtoFormat(historyItem.createdAt, 'DD/MM/YYYY - HH:mm:ss')
                : ''
              const approvedDate = historyItem.createdAt
                ? PulseOpsFormat.dateStringtoFormat(historyItem.approvedDate, 'DD/MM/YYYY - HH:mm:ss')
                : ''
              return {
                requestID: historyItem.requestId.toString(),
                status: historyItem.status,
                type: historyItem.type || '',
                creator: historyItem.createdBy,
                requestedDate: requestedDate,
                approver: historyItem.approver || '',
                approvedDate: approvedDate,
                groupMetrics: historyItem.oldMetric.groupMetrics,
                metricName: historyItem.oldMetric.metricName,
                value: historyItem.oldMetric.value,
                description: historyItem.oldMetric.description,
                oldOperator: historyItem.oldMetric.operator,
                newOperator: historyItem.newOperator,
                oldOperatorValue: historyItem.oldMetric.operatorValue,
                newOperatorValue: historyItem.newOperatorValue,
                oldRAGScore: historyItem.oldMetric.ragThreshold,
                newRAGScore: historyItem.newRagThreshold,
                oldMultiplier: historyItem.oldMetric.multiplier,
                newMultiplier: historyItem.newMultiplier
              }
            }
          )
          setSearchedMetricDetailList(searchedArr)
          setTotal(metricResponse.total)
        } else {
          setSearchedMetricDetailList([])
          setTotal(0)
        }
        return metricResponse
      }),
      ZIO.mapError((error) => {
        setSearchedMetricDetailList([])
        setTotal(0)
        return error
      }),
      bindLoader,
      ZIO.unsafeRun({})
    )
  }

  const onSearchEvent = () => {
    setPageNum(0)
    setPageSize(10)
    getSearchedList(0, 10)
  }

  const onPageChange = (pageNo: number, pageSi: number) => {
    setPageNum(pageNo)
    getSearchedList(pageNo, pageSi)
  }

  const onRowsPerPageChange = (pageNo: number, pageSi: number) => {
    setPageSize(pageSi)
    getSearchedList(pageNo, pageSi)
  }

  return (
    <View style={ACSharedStyles.wrapper}>
      <ScrollView style={ACSharedStyles.container} horizontal={false}>
        <View style={ACSharedStyles.headingContainer}>
          <Text style={ACSharedStyles.headingText}>{t('AdministratorConfig:HistoryDetail')}</Text>
        </View>
        <SectionContent>
          <SectionRow>
            <SectionCol>
              <Controller
                control={control}
                name={'from'}
                render={({ field: { onChange, onBlur, value }, fieldState: { error } }) => (
                  <DatePicker
                    alwaysShow
                    label={t('AdministratorConfig:From')}
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    maxDate={new Date()}
                    maxDateMessage={t('AdministratorConfig:MS990032')}
                    minDate={undefined}
                    minDateMessage={''}
                    errorMessage={error?.message}
                    labelStyle={OPLSharedStyles.datePickerText}
                  />
                )}
              />
            </SectionCol>
            <SectionCol>
              <Controller
                control={control}
                name={'to'}
                render={({ field: { onChange, onBlur, value }, fieldState: { error } }) => (
                  <DatePicker
                    alwaysShow
                    label={t('AdministratorConfig:To')}
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    maxDate={new Date()}
                    maxDateMessage={t('AdministratorConfig:MS990032')}
                    minDate={undefined}
                    minDateMessage={''}
                    errorMessage={error?.message}
                    labelStyle={OPLSharedStyles.datePickerText}
                  />
                )}
              />
            </SectionCol>
            <SectionCol>
              <Controller
                control={control}
                name={'groupMetric'}
                render={({ field: { onChange, onBlur, value }, fieldState: { error } }) => (
                  <SelectSearch
                    label={t('AdministratorConfig:GroupMetrics')}
                    options={metricGroups.map((item) => ({
                      value: item.groupId,
                      label: `${item.groupId} - ${item.groupMetrics}`
                    }))}
                    value={value}
                    onBlur={onBlur}
                    onChange={(val) => {
                      onChange(val)
                    }}
                    popupIcon={<assets.ArrowDownDropdownIcon />}
                    placeholder={t('AdministratorConfig:Select')}
                  />
                )}
              />
            </SectionCol>
          </SectionRow>
          <SectionRow sectionStyles={OPLSharedStyles.secondLine}>
            <SectionCol>
              <Controller
                control={control}
                name={'creator'}
                render={({ field: { onChange, onBlur, value }, fieldState: { error } }) => (
                  <Input title={t('AdministratorConfig:Creator')} value={value} onChange={onChange} onBlur={onBlur} />
                )}
              />
            </SectionCol>
            <SectionCol>
              <Controller
                control={control}
                name={'status'}
                render={({ field: { onChange, onBlur, value }, fieldState: { error } }) => (
                  <SelectSearch
                    label={t('AdministratorConfig:Status')}
                    options={ACMetricHistoryDetailConst.StatusConstList}
                    value={value}
                    onBlur={onBlur}
                    onChange={(val) => {
                      onChange(val)
                    }}
                    popupIcon={<assets.ArrowDownDropdownIcon />}
                    placeholder={t('AdministratorConfig:Select')}
                  />
                )}
              />
            </SectionCol>
          </SectionRow>
          {userPermissions.includes(Permission.SearchHistoryDetailBSCAdminConfig)}
          <View style={[OPLSharedStyles.buttonContainer, OPLSharedStyles.secondLine]}>
            <TouchableOpacity
              style={[sharedStyle.button, sharedStyle.btnRed, OPLSharedStyles.buttonContent]}
              onPress={() => onSearchEvent()}
            >
              <Text style={sharedStyle.textButtonRed}>{t('AdministratorConfig:Search')}</Text>
            </TouchableOpacity>
          </View>
        </SectionContent>
        <HightLightTable
          displayedColumns={displayedColumns}
          dataSource={searchedMetricDetailList}
          stickyHeader
          tableContainerClassName={useStyles().container}
          isPagination={true}
          totalRecord={total}
          pageSize={pageSize}
          pageNum={pageNum}
          setPageNum={setPageNum}
          setPageSize={setPageSize}
          rowsPerPageOptions={[10, 25, 50, 100]}
          onPageChange={onPageChange}
          onRowsPerPageChange={onRowsPerPageChange}
          showPaginationEnTranslation={true}
        ></HightLightTable>
      </ScrollView>
    </View>
  )
}
